export enum ClientPatronageApiTag {
  List = 'ClientPatronageList',
}

export const clientPatronageApiTags = Object.values(ClientPatronageApiTag);
